import AppData from '../appdata'

export default {
  data() {
    return {}
  },
  components: {},
  mixins    : [AppData],
  directives: {},
  watch     : {
    receivedOrderCount: {
      handler(newVal) {
        // console.log('receivedOrderCount::::::::', newVal)
        if (newVal > 0) {
          try {
            this.play()
            // eslint-disable-next-line no-empty
          } catch (e) {
          }
        } else {
          try {
            this.stop()
            // eslint-disable-next-line no-empty
          } catch (e) {
          }
        }
      },
      deep: true
    }
  },
  methods: {
    play() {
      try {
        if (this.orderSound) {
          this.orderSound.play()
        }
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    },
    stop() {
      try {
        if (this.orderSound) {
          this.orderSound.pause()
        }
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    }
  },
  computed: {
    defaultSoundName() {
      const soundName = this.appConfig?.LOCATION_DATA.Sound || ''
      return soundName === '0' ? '' : soundName
    },
    orderSound() {
      return this.defaultSoundName ? new Audio(this.appConfig.LOCATION_DATA.CdnUrl + 'assets/sound/' + this.defaultSoundName) : null
    },
    receivedOrderCount() {
      return this.orders.filter(order => parseInt(order.StatusId) === 11 || parseInt(order.StatusId) === 20 || parseInt(order.StatusId) === 0).length
    },
    orders() {
      const orders = this.$DataStore?.ordersDataToday?.items || []
      return orders.filter(order => parseInt(order.StatusId) > 0)
    }
  },
  created() {
    if (this.orderSound) {
      this.orderSound.loop = true
    }
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
    this.stop()
  }

}
